var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 15a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5.981 18.691a6.753 6.753 0 0 1 12.038 0","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Profile.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Profile;

Profile.default = Profile;
